import { getField, updateField } from 'vuex-map-fields';
import axios from 'axios';

const state = {
  contactInformation: {
    firstName: '',
    lastName: '',
    salutation: 'mr'
  },
  billingInformation: {
    companyName: '',
    addressLine1: '',
    addressLine2: '',
    zipCode: '',
    city: '',
    country: '',
    state: '',
    phone: '',
    vat: ''
  },
  shippingInformation: {
    addressLine1: '',
    addressLine2: '',
    zipCode: '',
    city: '',
    country: '',
    state: ''
  },
  sameShippingAddress: true,
  approveFollowUp: false,
  asps: [],
  selectedAsp: null,
  countries: [],
  pressBrakeBrands: [],
  selectedPressBrakeBrands: []
};

const actions = {
  async submitRegistrationForm({ state, rootState }) {
    const payload = {
      salutation: state.contactInformation.salutation,
      firstName: state.contactInformation.firstName,
      lastName: state.contactInformation.lastName,
      billing: state.billingInformation,
      authorizedServicePartner: {
        companyNumber: state.selectedAsp
      },
      approveFollowUp: state.approveFollowUp,
      pressBrakeBrands: state.selectedPressBrakeBrands.map((x) => ({
        pressBrakeBrand: x.value
      }))
    };

    if (!state.sameShippingAddress) {
      payload.shipping = state.shippingInformation;
    }

    console.info('submitRegistrationForm', payload);

    await axios.post('/Umbraco/Api/Registration/Create', payload, {
      params: {
        lang: rootState.culture
      }
    });

    window.location.reload();
  },
  async getAsps({ commit, state, rootState }) {
    try {
      const response = await axios.get(
        '/Umbraco/Api/Registration/FindAuthorizedServicePartners',
        {
          params: {
            country: state.billingInformation.country,
            state: state.billingInformation.state,
            lang: rootState.culture
          }
        }
      );

      commit('setAsps', response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async getCountryData({ commit }) {
    try {
      const response = await axios.get(
        '/Umbraco/Api/Countries/CountriesWithStates'
      );

      commit('setCountries', response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async getPressBrakeBrands({ commit, state, rootState }) {
    try {
      const config = {
        params: {
          action: 'get_press_brake_brands',
          culture: rootState.culture
        }
      };

      const { data } = await this._vm.$wiswiseproxyclient.post(
        {
          billing: {
            country_code: state.billingInformation.country
          }
        },
        config
      );
      commit('setPressBrakeBrands', data);
    } catch (error) {
      console.log(error);
    }
  }
};

const mutations = {
  updateField,
  setAsps(state, payload) {
    state.asps = payload;
  },
  setCountries(state, payload) {
    state.countries = payload;
  },
  resetSelectedAsp(state) {
    state.selectedAsp = null;
  },
  setPressBrakeBrands(state, payload) {
    state.pressBrakeBrands = payload.items.map((x) => ({
      key: x.press_brake_brand,
      value: x.press_brake_brand
    }));
  }
};

const getters = {
  getField,
  getSelectedAsp(state) {
    return state.asps.find((asp) => asp.CompanyNumber === state.selectedAsp);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
